import React from 'react';

import {Course, useCoursesQuery} from 'src/generated/graphql';

export const COURSE_IDS_DEV: string[] = ['1565838', '2776760', '3142166', '1565838', '1362070'];
export const COURSE_IDS_PROD: string[] = ['6969267', '7016501', '7016505', '7016509'];

export interface UseCoursesByIdsResult {
    count: number;
    isLoading: boolean;
    courses: Course[];
}

export const withFreeResourcesCoursesData = <T extends object>(
    WrappedComponent: React.ComponentType<T & {coursesResult: UseCoursesByIdsResult}>,
): React.ComponentType<T> => {
    return (props: T) => {
        const courseIds = process.env.DEPLOY_ENV === 'prod' ? COURSE_IDS_PROD : COURSE_IDS_DEV;
        const {data, isLoading} = useCoursesQuery<Course[]>(
            {ids: courseIds},
            {
                enabled: Boolean(courseIds.length),
                select: (response) => response.courses.filter(Boolean) as Course[],
            },
        );

        const coursesResult = React.useMemo(
            () => ({
                count: Number(courseIds.length),
                isLoading,
                courses: data ?? [],
            }),
            [courseIds.length, isLoading, data],
        );

        return <WrappedComponent {...props} coursesResult={coursesResult} />;
    };
};
